export function loadItems() {
  const columns = document.querySelectorAll(".acquaintance__column");

  columns.length &&
    columns.forEach((columns) => {
      const items = columns.querySelectorAll(".acquaintance__list-item");
      const loadMoreWrapper = columns.querySelector(
        ".acquaintance__load-wrapper"
      );

      for (let i = 0; i < 5 && i < items.length; i++) {
        items[i].style.display = "block";
      }

      const hiddenItemsCount = items.length - 5;

      if (hiddenItemsCount > 0) {
        const loadBtn = document.createElement("span");
        loadBtn.textContent = `Загрузить еще статьи (${hiddenItemsCount})`;
        loadMoreWrapper.appendChild(loadBtn);

        loadBtn.addEventListener("click", () => {
          for (let i = 5; i < items.length; i++) {
            items[i].style.display = "block";
          }
          loadMoreWrapper.removeChild(loadBtn);
        });
      }
    });
}
